<template>
  <div id="print-demo" class="print-html">
    <div class="print-box" v-for="(item, idx) in list" :key="idx">
      <certificate-template
        :id="`certificate_${idx}`"
        :ref="`certificate_${idx}`"
        :certificateData="item"
        @load="fileFinish($event, idx)"
        is-print
      />
      <div class="paging"></div>
    </div>
  </div>
</template>

<script>
import CertificateTemplate from "../../certificateTemplate/index.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import { Loading } from "element-ui";

export default {
  name: "print",
  components: {
    CertificateTemplate,
  },
  data() {
    return {
      printType: "html",
    };
  },
  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    fileFinish(isFinish, idx) {
      if (isFinish) {
        if (this.printType === "img") {
          const certificateDemo = this.$refs[`certificate_${idx}`][0].$el;
          html2canvas(certificateDemo, {
            allowTaint: true,
            scale: 2,
            useCORS: true, //图片跨域，开启跨域配置
          }).then((canvas) => {
            this.$set(this.list[idx], "imgSrc", canvas.toDataURL("image/jpeg"));
          });
        } else {
          this.$set(this.list[idx], "imgSrc", `certificate_${idx}`);
        }
      }
    },
    async htmlToCanvas(cb) {
      let focuser = setInterval(
        () => window.dispatchEvent(new Event("focus")),
        500
      );
      const loading = Loading.service({
        lock: true,
        text: "打印信息组装中…",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const timer = setInterval(() => {
        let isFinish = this.list.every((i) => i.imgSrc);
        try {
          if (isFinish) {
            clearInterval(timer);
            loading.close();
            if (this.printType === "img") {
              cb && cb(1);
              // 图片打印
              printJS({
                printable: this.list.map((i) => i.imgSrc), // 'printFrom', // 标签元素id
                type: "image",
                style: `@page { size: portrait; } body { text-align: center; margin: 5px; } .paging {page-break-after: always !important;}`,
                onPrintDialogClose: () => {
                  clearInterval(focuser);
                  this.handleAfterLeave();
                  cb && cb(2);
                },
              });
            } else {
              cb && cb(1);
              // html打印;
              printJS({
                printable: "print-demo",
                type: "html",
                targetStyles: ["*"],
                font: "",
                font_size: "",
                maxWidth: "",
                style: `@page { size: auto; }html{margin: 0;padding:0;width: 100%;} body { margin: 0;padding:0;width: 100%;
    height: 100%;font-size: 12px;line-height: 1;
    font-family: 'microsoft yahei',Arial,Helvetica,sans-serif;
    color: #666; } .paging { page-break-before: always !important; }`,
                onPrintDialogClose: () => {
                  clearInterval(focuser);
                  this.handleAfterLeave();
                  cb && cb(2);
                },
              });
            }
          }
        } catch (err) {
          clearInterval(timer);
          loading.close();
          console.log("打印失败");
        }
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.print-html {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  .print-box {
    overflow: hidden;
    width: 150px;
    height: 225px;
    ::v-deep .certificate-template {
      transform: scale(0.334, 0.334);
      transform-origin: top left;
    }
    ::v-deep .new-certificate-template {
      transform: scale(0.42, 0.42);
      transform-origin: top left;
    }
    .paging {
      display: block;
      position: relative;
      page-break-after: always !important;
    }
  }
}
@media print {
  .paging {
    page-break-before: always;
  }
}
</style>
